import Loading from "wrappers/Loading";
import React, { useEffect, useState } from "react";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import Page from "components/Page";
import { useHistory } from "react-router";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import useQueryParams from "hooks/useQueryParams";
import { urlFindErrorCode } from "constants/urls";
import { useDispatch } from "react-redux";
import { dataUsuarioVacio } from "../../constants";
import { dataUsuario } from "redux/actions/aLogin";

const SSOError = () => {
  const { code, redirect } = useQueryParams();
  const [loading, setLoading] = useState(true);
  const [catalogo, setCatalogo] = useState(null);
  const history = useHistory();

  const dispatch = useDispatch();

  const init = async () => {
    if (code) {
      const Data = {
        code,
      };
      const res = await ApiKeyFetch.instance().post(urlFindErrorCode, Data);
      if (res?.error) {
        setCatalogo(res.error);
      }
    }
    dispatch(dataUsuario(dataUsuarioVacio));
    setLoading(false);
  };
  useEffect(() => {
    init();
  }, []);

  const redirectToAmbiente = () => {
    if (redirect) {
      window.location.href = redirect;
    } else {
      history.push("/");
    }
  };

  return (
    <React.Fragment>
      <Loading loading={loading} message={"Cargando"}>
        <main className='cr-content'>
          <Page>
            <BreadCurmb showPaths={false} />
            <div className='row justify-content-center'>
              <div className='col-12'>
                <h1 className='display-3 text-mex text-center '>{catalogo?.title}</h1>
              </div>

              <div className='col-8'>
                <div className='d-flex justify-content-center text-justify'>
                  <p className='mt-4 font-source-sans-regular' style={{ fontSize: "20px" }}>
                    {catalogo?.description}
                  </p>
                </div>
              </div>
              <div className='col-12'>
                <div className='d-flex justify-content-center'>
                  <button
                    onClick={() => {
                      redirectToAmbiente();
                    }}
                    className='container-accidentes btn btn-block btn-primary btn-mis-datos text-uppercase col-4'
                    type='submit'>
                    Volver al inicio
                  </button>
                </div>
              </div>
            </div>
          </Page>
        </main>
      </Loading>
    </React.Fragment>
  );
};
export default SSOError;
